module.exports = __webpack_public_path__ + "img/source3_4.636919cd.png";